export default "__VITE_ASSET__ab95caf5__"